import tickSVG from '../../assets/tick.svg';

export const IntegrationTickAlert = ({ text }: { text: string }) => {
  return (
    <div className="whitespace-nowrap text-m font-bold text-success-drk">
      <img src={tickSVG} alt="Tick Icon" className="pr-[0.7rem]" />
      {text}
    </div>
  );
};
